import "@/App.css";
import LandingPage from "@/pages/LandingPage";
import GtmPage from "@/pages/GtmPage";

function App() {
  const path = window.location.pathname.replace(/\/+$/, "");
  if (path === "/gtm") return <GtmPage />;
  return <LandingPage />;
}

export default App;
